import { render, staticRenderFns } from "./generic-modal-confirm.vue?vue&type=template&id=c20ef08a&"
import script from "./generic-modal-confirm.vue?vue&type=script&lang=js&"
export * from "./generic-modal-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports